import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material"; // Note: Consider if these MUI components are still needed or if shadcn/ui alternatives are preferred
import { Input } from "@mui/material"; // Note: Consider if these MUI components are still needed or if shadcn/ui alternatives are preferred
import InputAdornment from "@mui/material/InputAdornment";
import Button from "react-bootstrap/Button"; // Note: Consider if this Bootstrap Button is still needed or if shadcn/ui Button is preferred
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import InputMask from "react-input-mask";
import { FiArrowRight } from "react-icons/fi";
import { BsFillLockFill } from "react-icons/bs"; // Removed BsBank, BsQrCode as they weren't used
// import QRCode from "react-qr-code"; // Removed as it wasn't used

// REMOVED react-toastify imports
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// ADDED shadcn/ui toast import
import { useToast } from "@/components/hooks/use-toast"; // Adjust path if necessary

import { Container, Row, Col } from "react-bootstrap";

import {
  Button as TButton, // Material Tailwind Button
  Card,
  CardHeader,
  CardBody,
  Typography,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  // Select, // Removed as it wasn't used
  // Option, // Removed as it wasn't used
  Badge,
  IconButton,
  // Avatar, // Removed as it wasn't used
} from "@material-tailwind/react";

// import { PiGraphThin } from "react-icons/pi"; // Removed as it wasn't used
// import { LuCloudCog } from "react-icons/lu"; // Removed as it wasn't used
// import { SiLooker } from "react-icons/si"; // Removed as it wasn't used
import {
  PiShoppingCartSimpleBold,
  PiMoneyBold,
  PiCreditCardLight,
} from "react-icons/pi";
// import { FaMoneyBillTransfer } from "react-icons/fa6"; // Removed as it wasn't used
import { FaGooglePay, FaApplePay } from "react-icons/fa6";

// import { Checkbox } from "@material-tailwind/react"; // Removed as it wasn't used

import dwml_title from "../../Assets/Midas/MidasLogo.png";
import Invoice from "./invoice";
import Product from "./product";
import CreditCardInput from "./CreditCardInput.jsx";

// ADDED shadcn/ui toast duration (optional, for consistency)
const SHADCN_TOAST_DURATION = 5000;

function Midas() {
  const { toast } = useToast(); // ADDED useToast hook

  const [state, setState] = useState({
    number: "",
    expiry: "",
    cvc: "",
    name: "",
    numLineItems: 4, // This seems to be overridden by itemsInCart for display
    taxRate: 12,
    focus: "",
  });
  const [radioValue, setRadioValue] = useState("Shopping");
  const [itemsInCart, setItemsInCart] = useState(0);
  // const [value, setValue] = React.useState(0); // Not directly used for payment method, type is used
  const [type, setType] = React.useState("card");
  // const [cardNumber, setCardNumber] = React.useState(""); // Handled by CreditCardInput's internal state or `state`
  // const [cardExpires, setCardExpires] = React.useState(""); // Handled by CreditCardInput's internal state or `state`
  const [cartItems, setCartItems] = useState([]);

  // const payment_options = [ // This was defined but not used
  //   { option: "Card" },
  //   { option: "EFT" },
  //   { option: "QR Code" },
  //   { option: "Apple Pay" },
  //   { option: "Google Pay" },
  // ];

  // const handleChange = (event, newValue) => { // This was defined but not used (related to `value` state)
  //   setValue(newValue);
  //   window.analytics.track("Change Payment Method", {
  //     target: mapping[value],
  //   });
  // };

  const handleInputChange = (evt) => {
    const { name, value } = evt.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputFocus = (evt) => {
    setState((prev) => ({ ...prev, focus: evt.target.name }));
  };

  // This mapping was used by the unused handleChange and the process payment analytics.
  // Let's update it to use the `type` state variable.
  const paymentTypeMapping = {
    card: "Card",
    "google pay": "Google Pay",
    "apple pay": "Apple Pay",
    // Add other types if they become actual payment methods
  };

  // These formatting functions were defined but not directly used in the JSX
  // They might be intended for CreditCardInput.jsx or were placeholders.
  // function formatCardNumber(value) {
  //   const val = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
  //   const matches = val.match(/\d{4,16}/g);
  //   const match = (matches && matches[0]) || "";
  //   const parts = [];
  //   for (let i = 0, len = match.length; i < len; i += 4) {
  //     parts.push(match.substring(i, i + 4));
  //   }
  //   if (parts.length) {
  //     return parts.join(" ");
  //   } else {
  //     return value;
  //   }
  // }

  // function formatExpires(value) {
  //   return value
  //     .replace(/[^0-9]/g, "")
  //     .replace(/^([2-9])$/g, "0$1")
  //     .replace(/^(1{1})([3-9]{1})$/g, "0$1/$2")
  //     .replace(/^0{1,}/g, "0")
  //     .replace(/^([0-1]{1}[0-9]{1})([0-9]{1,2}).*/g, "$1/$2");
  // }

  const handleCartAdd = (cartItem, operation) => {
    if (operation === "add") {
      setItemsInCart(itemsInCart + 1);
      // Ensure unique items or handle quantity updates if needed
      setCartItems((prevItems) => {
        const existingItem = prevItems.find(item => item.id === cartItem.id); // Assuming cartItem has an id
        if (existingItem) {
          // Optionally update quantity if items can be added multiple times
          // return prevItems.map(item => item.id === cartItem.id ? { ...item, quantity: (item.quantity || 1) + 1 } : item);
          return [...prevItems, cartItem]; // Or just add as a new line item if that's the logic
        }
        return [...prevItems, cartItem];
      });
    } else { // operation === 'remove'
      if (itemsInCart > 0) {
        setItemsInCart(itemsInCart - 1);
        // This remove logic needs to be more robust if multiple identical items can be added.
        // It currently removes the *first* item found with that name.
        // If items have unique IDs, filter by ID.
        setCartItems((prevItems) => {
          const itemIndex = prevItems.findIndex(
            (item) => item.name === cartItem.name // Assuming name is unique enough for this logic
          );
          if (itemIndex > -1) {
            const updated = [...prevItems];
            updated.splice(itemIndex, 1);
            return updated;
          }
          return prevItems; // Should not happen if itemsInCart was > 0 and item was in cart
        });
      }
    }
    // console.log(cartItems); // cartItems might not be updated immediately here due to async nature of setState
  };

  useEffect(() => {
    // console.log("Cart items updated:", cartItems); // Log here to see updated cartItems
  }, [cartItems]);


  return (
    <Container fluid className="project-section">
      {/* Ensure <Toaster /> from shadcn/ui is rendered in your root layout or a parent component */}
      <Container style={{ animation: `fadeIn 2s` }}>
        <div className="image-container py-8">
          <img src={dwml_title} width={"300px"} height={"100px"} alt="logo" />
        </div>

        <div className="float-right"> {/* Consider using Tailwind classes for positioning if moving away from Bootstrap grid */}
          <Badge
            content={String(itemsInCart)}
            className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2" // Material Tailwind badge might need different positioning classes
          >
            <IconButton
              onClick={() => {
                // REPLACED react-toastify with shadcn/ui toast
                toast({
                  title: "Checkout Information",
                  description: "This will take you to the checkout/invoicing screen",
                  duration: SHADCN_TOAST_DURATION,
                });
              }}
            >
              <PiShoppingCartSimpleBold className="h-6 w-6" color="black" />
            </IconButton>
          </Badge>
        </div>

        <Tabs value={radioValue} className="overflow-hidden py-8 w-full">
          <TabsHeader className="relative z-0 ">
            <Tab value="Shopping" onClick={() => setRadioValue("Shopping")}>
              <div className="flex items-center">
                <PiShoppingCartSimpleBold className="pr-2" size={28} /> Shopping
              </div>
            </Tab>
            <Tab value="Paying" onClick={() => setRadioValue("Paying")}>
              <div className="flex items-center">
                <PiMoneyBold className="pr-2" size={28} /> Paying
              </div>
            </Tab>
          </TabsHeader>

          <TabsBody className="!overflow-x-hidden !overflow-y-visible"> {/* Consider removing !important flags if possible */}
            <TabPanel value="Shopping" className="p-0">
              <div className="flex flex-wrap justify-center gap-12 py-8">
                {/* Assuming Product component takes an id or key for proper list rendering */}
                <Product addition={handleCartAdd} id="product1" name="Product Alpha"/>
                <Product addition={handleCartAdd} id="product2" name="Product Beta"/>
                <Product addition={handleCartAdd} id="product3" name="Product Gamma"/>
                <Product addition={handleCartAdd} id="product4" name="Product Delta"/>
                <Product addition={handleCartAdd} id="product5" name="Product Epsilon"/>
                <Product addition={handleCartAdd} id="product6" name="Product Zeta"/>
              </div>
            </TabPanel>

            <TabPanel value="Paying" className="p-0">
              <Card className="w-full ">
                <CardHeader
                  floated={false}
                  shadow={false}
                  className="m-0 grid place-items-center rounded-b-none pt-8 pb-2 px-4 text-center"
                >
                  <Typography variant="h4" color="black">
                    Ashes Checkout
                  </Typography>
                </CardHeader>
                <CardBody>
                  <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Input // This is an MUI Input
                        type="number"
                        name="numLineItems"
                        value={itemsInCart} // Displaying dynamic itemsInCart
                        onFocus={handleInputFocus}
                        disabled
                        placeholder="Number of Line Items"
                        startAdornment={
                          <InputAdornment position="start">
                            Number of Line Items
                          </InputAdornment>
                        }
                        fullWidth // Good practice for MUI inputs in grids
                      />

                      <Input // This is an MUI Input
                        type="number"
                        name="taxRate"
                        value={state.taxRate}
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        placeholder="Tax Rate"
                        startAdornment={
                          <InputAdornment position="start">
                            Tax Rate %
                          </InputAdornment>
                        }
                        fullWidth // Good practice for MUI inputs in grids
                      />

                      <Invoice
                        numberlineItems={itemsInCart}
                        taxRate={state.taxRate}
                        items={cartItems}
                      />
                    </div>

                    <div>
                      <Tabs value={type}>
                        <TabsHeader className="overflow-x-auto no-scrollbar flex-nowrap "> {/* Changed flex-no-wrap to flex-nowrap */}
                          <Tab value="card" onClick={() => setType("card")}>
                            <PiCreditCardLight className="pr-2" size={42} />
                          </Tab>
                          <Tab
                            value="google pay"
                            onClick={() => setType("google pay")}
                          >
                            <FaGooglePay className="pr-2" size={42} />
                          </Tab>
                          <Tab
                            value="apple pay"
                            onClick={() => setType("apple pay")}
                          >
                            <FaApplePay className="pr-2" size={36} />
                          </Tab>
                        </TabsHeader>
                        <TabsBody className="!overflow-x-hidden !overflow-y-hidden"> {/* Consider removing !important flags */}
                          <TabPanel value="card" className="p-0">
                            <CreditCardInput /> {/* This component handles its own state for card details */}
                          </TabPanel>

                          <TabPanel value="google pay" className="p-0">
                            <div className="py-8 rounded-lg text-black text-center">
                              <img
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Google_Pay_Logo.svg/2560px-Google_Pay_Logo.svg.png"
                                alt="Google Pay Logo"
                                className="mx-auto mb-4 h-12"
                              />
                              <h3 className="text-2xl font-semibold mb-2"> {/* Changed font-bold to font-semibold */}
                                Use Google Pay
                              </h3>
                              <p className="text-sm mb-4">
                                Fast, secure payments with Google Pay.
                              </p>
                            </div>
                          </TabPanel>

                          <TabPanel value="apple pay" className="p-0">
                            <div className="py-8 rounded-lg text-black text-center">
                              <img
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Apple_Pay_logo.svg/2560px-Apple_Pay_logo.svg.png"
                                alt="Apple Pay Logo" // Corrected alt text
                                className="mx-auto mb-4 h-12"
                              />
                              <h3 className="text-2xl font-semibold mb-2"> {/* Changed font-bold to font-semibold */}
                                Use Apple Pay
                              </h3>
                              <p className="text-sm mb-4">
                                Fast, secure payments with Apple Pay.
                              </p>
                            </div>
                          </TabPanel>
                        </TabsBody>
                      </Tabs>
                    </div>
                  </div>
                  <div className="py-4">
                    {/* This is a react-bootstrap Button. Consider replacing with Material Tailwind or shadcn/ui button for consistency */}
                    <Button
                      className="dwml-repo-button w-full" // dwml-repo-button might be custom, ensure it styles appropriately
                      onClick={() => {
                        // REPLACED react-toastify with shadcn/ui toast
                        toast({
                          title: "Payment Status",
                          description: "Let's pretend the payment has processed",
                          duration: SHADCN_TOAST_DURATION,
                        });
                        if (window.analytics) {
                           window.analytics.track("Payment Process", {
                            target: paymentTypeMapping[type] || type, // Use the mapping or fallback to type
                            line_items: itemsInCart, // Using dynamic itemsInCart
                            tax_rate: state.taxRate,
                          });
                        }
                      }}
                      variant="primary" // Bootstrap variant
                    >
                      <div className="flex text-center justify-center items-center rounded-lg"> {/* Removed align-middle (covered by items-center) */}
                        <p className="mb-0 mr-2">Process Payment</p> {/* Added margin to paragraph */}
                        <FiArrowRight />
                      </div>
                    </Button>

                    <Typography
                      variant="small"
                      color="gray"
                      className="mt-2 flex items-center justify-center gap-2 font-normal opacity-60"
                    >
                      <BsFillLockFill size={12} />
                      Payments are secure and encrypted
                    </Typography>
                  </div>
                </CardBody>
              </Card>
            </TabPanel>
          </TabsBody>
        </Tabs>
      </Container>
    </Container>
  );
}

export default Midas;